export default "__VITE_ASSET__a809bfa8__"